import { getItem, removeItem, STORAGE_KEYS } from '../storage';
import { MCP_LOGIN_PATH } from '../../helpers/constants';

// La sesión es un JWT que firma el back tras verificar el id_token de Google y
// caduca a las JWT_TTL (12 h). No se renueva en silencio a propósito: el back
// fija `auth_time` al login de Google, así que un token robado no puede
// "rejuvenecerse" a sí mismo. Al caducar se vuelve a iniciar sesión con Google.

// `exp` (segundos) del JWT, o null si no se puede leer. Solo se usa para avisar
// antes de tiempo: la validez real la decide siempre el back.
export const expiracionJwt = (token) => {
  try {
    const base64 = token.split('.')[1].replace(/-/g, '+').replace(/_/g, '/');
    const { exp } = JSON.parse(atob(base64));
    return Number.isFinite(exp) ? exp : null;
  } catch {
    return null;
  }
};

export const sesionCaducada = (ahoraMs = Date.now()) => {
  const token = getItem(STORAGE_KEYS.USER)?.tokenId;
  if (!token) return false;
  const exp = expiracionJwt(token);
  return exp !== null && exp * 1000 <= ahoraMs;
};

// Cierra la sesión local y vuelve al login con el aviso de sesión caducada.
// La ruta actual ya queda en LAST_PATH (App.js), así que tras entrar se vuelve a ella.
export const cerrarSesionCaducada = () => {
  if (window.location.pathname === MCP_LOGIN_PATH) return;
  if (getItem(STORAGE_KEYS.USER) === null) return;
  sessionStorage.setItem('apiError', 'sesion-caducada');
  removeItem(STORAGE_KEYS.USER);
  window.location.href = '/';
};
